import React, { ReactElement } from 'react'
import { Text } from '../../atoms'
import ControlHighlight from '../KeyboardControls/ControlHighlight'
import { useKeyboardControls } from '../../../contexts/KeyboardControlsContext'
import KeyboardControl from '../KeyboardControls/KeyboardControl'
import { HighlightEffect } from '../../../enums/KeyboardControls'
interface ContactLinkProps {
  id?: string
  className?: string
  onFocus?: () => void
}

export enum FocusableElement {
  InputEmail = 'input-email',
  ButtonContinue = 'button-continue',
  LinkContact = 'link-contact',
}

const ContactLinks: React.FC<ContactLinkProps> = ({
  id,
  className,
  onFocus,
  ...rest
}: ContactLinkProps): ReactElement => {
  const keyboardControls = useKeyboardControls()

  return (
    <div className={`${className ?? ''} text-center pt-6`} {...rest}>
      <Text
        type='paragraph'
        text='Need help?'
        size='BASE'
        className='inline-block leading-[3rem] font-thin text-white'
      />
      {' '}
      <ControlHighlight
        active={keyboardControls.isEnabled && keyboardControls.isElementFocused(FocusableElement.LinkContact)}
        useSpan
        highlightEffect={HighlightEffect.LinkUnderline}
        data-testid={`highlight-${FocusableElement.LinkContact}`}
      >
        <span>
          <KeyboardControl>
            <a
              id={id ?? ''}
              data-testid={id ?? ''}
              onFocus={onFocus}
              className='underline text-dopage-primary'
              href='mailto:houston@dopa.ge'
            >
              <Text
                type='span'
                text='Contact Us'
                size='BASE'
              />
            </a>
          </KeyboardControl>
        </span>
      </ControlHighlight>
    </div>
  )
}

export default ContactLinks
